import { get } from 'lodash'

const getFFDestinationHost = (organization) => {
  const ffHost = process.env.FF_APP_URL
  const ffSubdomain = get(organization, 'ffSubdomain')
  return ffHost.replace('{{ffSubdomain}}', ffSubdomain || 'my')
}

export default getFFDestinationHost
